const entryIds = new WeakMap<File, string>();
let nextEntryId = 0;

/** File identity survives array reordering and duplicate filenames. */
export function subtitleEntryId(file: File): string {
  let id = entryIds.get(file);
  if (!id) {
    id = `subtitle-${++nextEntryId}`;
    entryIds.set(file, id);
  }
  return id;
}
